import { CKButton } from '@clearkit/react';
import MuiInput from '@material-ui/core/Input';

import Close from './Close.svg';
import styles from './styles';

const Scores = ({ classes, selectedScore, onSelectScore }) => {
  let scores = [];

  for (let i = 1; i <= 10; i++) {
    scores.push(
      <button
        key={`score-${i}`}
        onClick={() => onSelectScore(i)}
        className={classnames(classes.scoreOption, {
          [classes.selectedScoreOption]: selectedScore === i,
        })}>
        {i}
      </button>,
    );
  }

  return (
    <div
      className={classnames(classes.scores, {
        [classes.surveyExpanded]: selectedScore !== undefined,
      })}>
      {scores}
    </div>
  );
};

const Comment = ({ onSubmit, classes }) => {
  const [inputValue, setInputValue] = useState();

  const onClickSubmit = () => onSubmit(inputValue);

  return (
    <>
      <div className={classes.surveyQuestion}>
        Why did you choose that score?
      </div>
      <MuiInput
        multiline
        autoFocus
        fullWidth
        rows="5"
        onChange={(e) => setInputValue(e.target.value)}
        placeholder="Let us know what's working well and what could be improved"
        className={classes.input}
      />
      <div style={{ textAlign: 'right' }}>
        <CKButton variant="bold" variantColor="blue" onClick={onClickSubmit}>
          Submit feedback
        </CKButton>
      </div>
    </>
  );
};

const SuccessMessage = ({ onDismiss, classes, score }) => {
  return (
    <div>
      <div className={classes.successScore}>{score}</div>
      <div className={classes.successMessageText}>
        Thank you for taking a moment to let us know your thoughts on Clearbit
        X!
      </div>
      <div style={{ textAlign: 'center' }}>
        <CKButton variant="secondary" onClick={onDismiss}>
          Dismiss
        </CKButton>
      </div>
    </div>
  );
};

const NPS = ({
  classes,
  onClose,
  onSelectScore: onSelectScoreProp,
  onSubmitComment: onSubmitCommentProp,
}) => {
  const [selectedScore, setSelectedScore] = useState();
  const [submitted, setSubmitted] = useState(false);

  const onSubmitComment = (value) => {
    setSubmitted(true);
    onSubmitCommentProp(value);
  };

  const onSelectScore = (score) => {
    setSelectedScore(score);
    onSelectScoreProp(score);
  };

  return (
    <div className={classes.container}>
      {!submitted && (
        <>
          <div
            className={classnames(classes.headline, {
              [classes.headlineGray]: selectedScore !== undefined,
            })}>
            How likely are you to recommend Clearbit to a colleague?
          </div>
          <a
            role="button"
            onClick={onClose}
            className={classes.close}
            tabIndex={0}>
            <Close />
          </a>
          <Scores
            classes={classes}
            selectedScore={selectedScore}
            onSelectScore={onSelectScore}
          />
        </>
      )}
      {selectedScore !== undefined && !submitted && (
        <Comment onSubmit={onSubmitComment} classes={classes} />
      )}
      {submitted && (
        <SuccessMessage
          score={selectedScore}
          onDismiss={onClose}
          classes={classes}
        />
      )}
    </div>
  );
};

NPS.propTypes = {
  classes: PropTypes.shape({}),
  onClose: PropTypes.func,
  onSelectScore: PropTypes.func,
  onSubmitComment: PropTypes.func,
};

export default withStyles(styles)(NPS);
